module.exports = __webpack_public_path__ + "static/img/70.c20f39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/70.png
// module id = zzqs
// module chunks = 0